/**
 * APM Barcode Scanner — storefront product search via device camera
 * Uses ZXing-js to decode EAN-13, EAN-8, Code 128 barcodes
 */
(function () {
  var ZXING_CDN = 'https://cdn.jsdelivr.net/npm/@zxing/library@0.21.3/umd/index.min.js';

  function init() {
    document.querySelectorAll('[data-barcode-scan]').forEach(function (btn) {
      btn.addEventListener('click', openScanner);
    });
  }

  function openScanner() {
    var overlay = document.createElement('div');
    overlay.id = 'apm-barcode-overlay';
    overlay.innerHTML = [
      '<div class="apm-bs-modal">',
      '  <div class="apm-bs-header">',
      '    <span>Scan Product Barcode</span>',
      '    <button class="apm-bs-close" type="button" aria-label="Close">&times;</button>',
      '  </div>',
      '  <div class="apm-bs-video-wrap">',
      '    <video class="apm-bs-video" autoplay muted playsinline></video>',
      '    <div class="apm-bs-line"></div>',
      '  </div>',
      '  <p class="apm-bs-hint">Point camera at product barcode</p>',
      '</div>'
    ].join('');
    document.body.appendChild(overlay);

    var video = overlay.querySelector('.apm-bs-video');
    var closeBtn = overlay.querySelector('.apm-bs-close');

    function close() { cleanup(overlay); }
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    if (typeof ZXing !== 'undefined') {
      startScan(video, overlay);
    } else {
      var s = document.createElement('script');
      s.src = ZXING_CDN;
      s.onload = function () { startScan(video, overlay); };
      s.onerror = function () {
        showError(overlay, 'Could not load barcode library. Please check your connection.');
      };
      document.head.appendChild(s);
    }
  }

  function startScan(video, overlay) {
    var hints = new Map();
    hints.set(ZXing.DecodeHintType.POSSIBLE_FORMATS, [
      ZXing.BarcodeFormat.EAN_13,
      ZXing.BarcodeFormat.EAN_8,
      ZXing.BarcodeFormat.CODE_128,
      ZXing.BarcodeFormat.CODE_39,
      ZXing.BarcodeFormat.UPC_A,
      ZXing.BarcodeFormat.UPC_E
    ]);

    var reader = new ZXing.BrowserMultiFormatReader(hints);
    overlay._reader = reader;

    reader.decodeFromVideoDevice(null, video, function (result, err) {
      if (!result) return;
      var barcode = result.getText();
      cleanup(overlay);
      doSearch(barcode);
    });
  }

  function doSearch(barcode) {
    /* Redirect to search page filtered to products */
    window.location = '/search?type=product&q=' + encodeURIComponent(barcode);
  }

  function cleanup(overlay) {
    if (overlay._reader) {
      try { overlay._reader.reset(); } catch (e) {}
    }
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
  }

  function showError(overlay, msg) {
    var hint = overlay.querySelector('.apm-bs-hint');
    if (hint) { hint.textContent = msg; hint.style.color = '#c0392b'; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();